<template>
  <div>
    <breadcrumbs :home="$t('title')">
      <template v-slot:left v-if="incompleteCount">
        <list-notification v-model="showStatus">
          <v-list-item>
            <v-icon>mdi-arrow-right-thin</v-icon>
            {{incompleteCount}} incomplete fermentation{{incompleteCount===1?'':'s'}}
            <v-spacer/>
            <v-btn small color="warning" @click="showStatus=false;$nextTick(() => {filters.completeStatus='0';filters.wineId=null;filters.from=null;filters.to=null,filters.number=''})">View</v-btn>
          </v-list-item>
        </list-notification>
      </template>

      <template v-slot:right>
        <v-menu offset-y v-if="company.permissions.includes('config.write')" :close-on-content-click="false" nudge-bottom="5" left max-width="500">
          <template v-slot:activator="{ on:prefMenu }">
            <v-tooltip bottom>
              <template v-slot:activator="{on:tooltip}">
                <v-icon small v-on="{...prefMenu,...tooltip}">mdi-tune-variant</v-icon>
              </template>
              Wine fermenting preferences
            </v-tooltip>
          </template>
          <production-wine-fermenting-preferences/>
        </v-menu>
      </template>
    </breadcrumbs>

<!--
    <v-dialog v-model="showGraph" width="496">
      <component :is="graph" zoomed @close="showGraph=false" :from="graphFrom" :to="graphTo" disableTo/>
    </v-dialog>
-->

    <purtrak-table name="winefermenting" objectType="wine fermentations" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select show-expand
                   listEndPoint="wineFermentations" v-model="selected"
                   fields="id,date,number,wine{id,name},osg,fsg,ph,alc,duration,volume,value,comments,completed,lot,hasNotes"
                   totalFields="totalVolume,totalValue"
                   :totals.sync="totals"
                   :listFilters="listFilters"
                   @dblclick="fermentation => $router.push({name:'ProductionWineFermentingEdit',params:{fermentationId:fermentation.id}})"
                   :item-class="fermentation => (fermentation.completed ? '' : 'warning--text')"
                   @itemExpanded="({item, value}) => expand(item, value)"
                   title="Wine fermenting"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',filters.completeStatus!=null?(filters.completeStatus=='1'?'Completed':'Incomplete'):'',filters.wineId!=null?wineName:'']}"
                   download-endpoint="wineFermentationExportCSV"
                   >

      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.completeStatus=null;filters.wineId=null;filters.from=null;filters.to=null;filters.number=''">
          <v-list-item>
            <filter-search label="Number" v-model="filters.number"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item v-if="preferences.incomplete">
            <v-autocomplete label="Completed" dense outlined :items="[{value:null,text:'All'},{divider:true},{value:'1',text:'Completed'},{value:'0',text:'Incomplete'}]" v-model="filters.completeStatus"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Wine produced" dense outlined :items="wines" item-text="name" item-value="id" v-model="filters.wineId"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.number!=''" close small class="ml-1" @click:close="filters.number=''">#: {{filters.number}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.completeStatus!=null" close small class="ml-1" @click:close="filters.completeStatus=null">{{filters.completeStatus=='1'?'Completed':'Incomplete'}}</v-chip>
          <v-chip v-show="filters.wineId!=null" close small class="ml-1" @click:close="filters.wineId=null">{{wineName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'ProductionWineFermentingEditNew'}"><v-list-item-title>Create fermentation</v-list-item-title></v-list-item>
          <v-divider/>
        </template>

            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Wine fermenting',to:{name:'ProductionWineFermenting'}}]},query:{to:'reports/production/ReportsWineFermentingActivity'}}">
              <v-list-item-title>Wine fermenting activity</v-list-item-title>
            </v-list-item>

<!--
        <v-list-item :to="{name:'ProductionWineFermentingMashBills'}"><v-list-item-title>Mash bills</v-list-item-title></v-list-item>
        <v-menu :nudge-left="220" v-if="!$vuetify.breakpoint.mobile">
          <template v-slot:activator="{on:reports}">
            <v-list-item v-on="reports">
              <v-list-item-title>Reports and graphs</v-list-item-title>
              <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'WineFermenting',to:{name:'ProductionWineFermenting'}}]},query:{to:'reports/production/ReportsWineFermentingActivity'}}">
              <v-list-item-title>WineFermenting activity</v-list-item-title>
              <v-list-item-action-text>Report</v-list-item-action-text>
            </v-list-item>
            <v-divider/>
            <v-list-item @click="getGraph('DashboardMashSummary')">
              <v-list-item-title>WineFermenting rate</v-list-item-title>
              <v-list-item-action-text>Graph</v-list-item-action-text>
            </v-list-item>
            <v-list-item @click="getGraph('DashboardMashHistory')">
              <v-list-item-title>WineFermenting history</v-list-item-title>
              <v-list-item-action-text>Graph</v-list-item-action-text>
            </v-list-item>
          </v-list>
        </v-menu>
-->
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="printBatch()"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.date="{item,value,printing}">
        {{value | formatDateTime}}
        <div v-if="!item.completed && !printing" class="text-caption"><em>INCOMPLETE</em></div>
      </template>
      <template v-slot:item.lot="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <v-hover v-else-if="item.lot" v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[{text:'Wine fermenting',to:{name:'ProductionWineFermenting'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:1}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.duration="{value}">
        {{value | duration}}
      </template>
      <template v-slot:item.volume="{value}">
        {{value | number(0)}}
      </template>
      <template v-slot:item.value="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.alc="{value}">
        {{value | number(1)}}%
      </template>
      <template v-slot:item.ph="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:item.fsg="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:item.osg="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'ProductionWineFermentingEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:header.notes>
        <v-icon>mdi-history</v-icon>
      </template>
      <template v-slot:item.notes="{item}">
        <v-btn icon :color="item.hasNotes?'green':'grey lighten-2'" small @click="wineFermentation=item;showNotes=true"><v-icon>mdi-history</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Wine fermentation operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ProductionWineFermentingEdit',params:{fermentationId:item.id}}"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item @click="print(item.id, null, true)"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="wineFermentation=item;showNotes=true"><v-list-item-title>Notes</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Wine fermenting',to:{name:'ProductionWineFermenting'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:1}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="setFsg(item)"><v-list-item-title>Final {{preferences.brix?'brix':'specific gravity'}}</v-list-item-title></v-list-item>
              <v-divider/>
              <v-list-item @click="updateComments(item)"><v-list-item-title>Update comments</v-list-item-title></v-list-item>
              <v-list-item @click="wineFermentation=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete wine fermentation</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='volume'">
              {{totals.totalVolume | number(0)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card class="my-4" :class="expansionPanelClass">
          <v-container>
            <v-row dense>
              <v-col cols="6">
                <v-simple-table dense class="pl-4 text-caption" :class="expansionPanelClass" style="width:100%">
                  <thead>
                    <tr>
                      <th :class="expansionPanelClass" width="40%">Item</th>
                      <th :class="expansionPanelClass" width="10%">Lot</th>
                      <th class="text-right" :class="expansionPanelClass" width="30%">{{item.completed?'':'Pending '}}Quantity</th>
                      <th class="text-right" :class="expansionPanelClass" width="20%" v-if="values && item.completed">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(fermenterItem,index) of item.items" :key="index">
                      <td class="text-caption">{{fermenterItem.itemName}}</td>
                      <td class="text-caption">
                        <a @click="$router.push({name:'ReportsView',params:{back:[{text:'WineFermenting',to:{name:'ProductionWineFermenting'}}]},query:{to:'reports/inventory/ReportsLot',id:fermenterItem.itemId,lot:fermenterItem.lot,forward:0}})">{{fermenterItem.itemType === 'Item' ? fermenterItem.lot : ''}}</a>
                      </td>
                      <td class="text-caption text-right">{{fermenterItem.quantity | number(fermenterItem.itemPrecision)}} {{fermenterItem.itemUnits}}</td>
                      <td class="text-caption text-right" v-if="values && item.completed">{{fermenterItem.value | currency}}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="1"/>
              <v-col cols="5">
                <v-simple-table dense class="pl-4 text-caption" :class="expansionPanelClass" style="width:100%">
                  <thead>
                    <tr>
                      <th :class="expansionPanelClass" width="50%">Tank</th>
                      <th class="text-right" :class="expansionPanelClass" width="30%">{{item.completed?'':'Pending '}}Volume</th>
                      <th class="text-right" :class="expansionPanelClass" width="20%" v-if="values && item.completed">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tank of item.tanks" :key="tank.tankId">
                      <td class="text-caption">{{tank.tankName}}</td>
                      <td class="text-caption text-right">{{tank.volume | number(0)}} litres</td>
                      <td class="text-caption text-right" v-if="values && item.completed">{{tank.value | currency}}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
          </v-card>
        </td>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected fermentations':'this wine fermentation'" @delete="performDelete(wineFermentation.id)"/>
    <component :is="dialog" v-bind="dialogProperties" @done="dialog = null"/>

    <v-dialog v-model="setFSG" persistent max-width="300">
      <v-card>
        <v-card-title>Final {{preferences.brix ? 'brix' : 'specific gravity'}}</v-card-title>
        <v-divider/>
        <v-card-text class="pb-0 pt-2">
          <v-form ref="fsg">
            <v-container>
              <v-row>
                <v-col cols="8" v-if="preferences.brix">
                  <decimal-number-input label="Final Brix" v-model="fsg" prefix="" suffix="°Bx" :precision="1" :max="100"/>
                </v-col>
                <v-col cols="8" v-else>
                  <decimal-number-input label="Final specific gravity" v-model="fsg" prefix="" suffix="" :precision="3"  :max="1.9"/>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="setFSG=false">Cancel</v-btn>
          <v-btn color="primary" @click="saveFSG">Set</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <production-wine-fermenting-notes :fermentationId="wineFermentation.id" v-model="showNotes" :hasNotes.sync="wineFermentation.hasNotes"/>
  </div>
</template>

<script>
import googleCharts from '@/mixins/googleCharts'
import performDelete from '@/mixins/performDelete'
import {format,add} from 'date-fns'
import ProductionWineFermentingNotes from '@/views/production/wineFermenting/ProductionWineFermentingNotes'
import productionWineFermentingPrint from '@/views/production/wineFermenting/productionWineFermentingPrint'
import ProductionWineFermentingPreferences from '@/views/production/wineFermenting/ProductionWineFermentingPreferences'

export default {
  name: 'ProductionWineFermenting',
  mixins: [productionWineFermentingPrint,googleCharts,performDelete],
  components: {ProductionWineFermentingNotes,ProductionWineFermentingPreferences},
  props: {
    wineId: {type:String, required:false, default:null}
  },
  data() {
    return {
      incompleteCount: 0,
      showStatus: false,
      filters: {
        number: '',
        from: null,
        to: null,
        completeStatus: null,
        wineId: this.wineId,
      },
      dateDisplay: '',
      preferences: {},
      wineFermentation: {},
      completeOptions: [{name:'Completed/Incomplete',value:0},{divider:true},{name:'Completed only',value:1},{name:'Incomplete only',value:2}],
      wines: [{name:'All wines',id:null},{divider:true}],
      totals: {totalValue:0, totalVolume:0},
      showDelete: false,
      deleteMultiple: false,
			dialog: null,
      dialogProperties: {},
      setFSG: false,
      fsg: 0,
      showNotes: false,
      graphFrom: '',
      graphTo: '',
      graph: null,
      showGraph: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'number', visible:true},
                       { value: 'notes', visible:true,excludeFromExport:true},
                       { value: 'wine.name', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'duration' ,visible:false},
                       { value: 'lot', visible:true},
                       { value: 'fsg', visible:false},
                       { value: 'osg', visible:false},
                       { value: 'alc', visible:true},
                       { value: 'ph', visible:false},
                       { value: 'volume', visible:true},
                       { value: 'value', visible:true}],
      headers: [{ text: this.$t('header.date'), value: 'date', width:'15%',sortable:true},
                { text: '#', value: 'number', width:'10%',sortable:true},
                { text: '', value: 'notes', width:'5%',sortable:false,align:'center',print:false},
                { text: this.$t('header.produces'), value: 'wine.name', width:'25%',sortable:true},
                { text: this.$t('header.comments'), value: 'comments', width:'10%',sortable:true},
                { text: this.$t('header.duration'), value: 'duration', width:'10%',sortable:true, omit:() => !this.preferences.duration},
                { text: this.$t('header.lot'), value: 'lot', width:'10%',sortable:true},
                { text: this.$t('header.fsg'), value: 'fsg', width:'10%',sortable:true,align:'right'},
                { text: this.$t('header.osg'), value: 'osg', width:'10%',sortable:true,align:'right'},
                { text: this.$t('header.alc'), value: 'alc', width:'10%',sortable:true,align:'right'},
                { text: this.$t('header.ph'), value: 'ph', width:'10%',sortable:true,align:'right'},
                { text: this.$t('header.litres'), value: 'volume', width:'15%',align:'right',sortable:true},
                { text: this.$t('header.value'), value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values}],

    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    values() {
      return this.company.permissions.includes('values');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    wineName() {
      return this.wines.find(wine => wine.id === this.filters.wineId)?.name;
    },
    listFilters() {
      const filters = [];
      if (this.filters.number)
        filters.push({field:'number', comparator:'contains', value:this.filters.number});
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.completeStatus == '1' || this.filters.completeStatus == '0')
        filters.push({field:'completed', comparator:'eq', value:this.filters.completeStatus == '1' ? 'true' : 'false'});
      if (this.filters.wineId !== null)
        filters.push({field:'wineId', comparator:'eq', value:this.filters.wineId});
      return filters;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');
    this.loading = true;
    this.$lazyListLoad(this.wines, 'wines2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    const results = await this.$apiCall(`query ProductionWineFermenting {
                                              wineFermentationPreferences {
                                                brix,duration,incomplete
                                              }
                                            }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.wineFermentationPreferences;
    await this.getStatus();
    this.graphTo = format(new Date(), 'yyyy-MM-dd');
    this.graphFrom = format(add(new Date(), {years:-2}), 'yyyy-MM-dd');
    this.loading = false;

    if (!['ProductionWineFermentingEdit', 'ProductionWineFermentingEditNew'].includes(this._previousRoute) &&
        Object.keys(this.$route.query).length === 0 &&
        this.incompleteCount && !localStorage.getItem('hideNotification')) {
      this.$nextTick(() => this.showStatus = true);
      setTimeout(() => this.showStatus = false, 10_000);  // Close in 10 seconds
    }
  },
  methods: {
    async getStatus() {
      const results = await this.$apiCall(`query ProductionWineFermenting {
                                             wineFermentationsIncomplete
                                          }`);
      if (!results.error)
        this.incompleteCount = results.data.wineFermentationsIncomplete;
    },
    async getGraph(name) {
      await this.loadGoogleCharts();
      this.graph = () => import(`@/views/dashboard/${name}`);
      this.showGraph = true;
    },

    async expand(item, value) {
      if (value && !item.items) {
        this.loading = true;
        const results = await this.$apiCall(`query ProductionWineFermenting($id:ID!) {
                                                  wineFermentation(id:$id) {
                                                    items{itemName,itemId,itemType,quantity,itemUnits,itemPrecision,value,lot},
                                                    tanks{tankId,tankName,volume,value}
                                                  }
                                                }`,
                                            {id:item.id});
        this.$set(item, 'items', results.data.wineFermentation.items);
        this.$set(item, 'tanks', results.data.wineFermentation.tanks);
        this.loading = false;
      }
    },

    updateComments(wineFermentation) {
      this.dialogProperties = {item:wineFermentation, operation:'wineFermentationUpdateComments'};
      this.dialog = () => import(`@/views/production/ProductionUpdateComments`);
    },
    setFsg(wineFermentation) {
      this.wineFermentation = wineFermentation;
      this.fsg = this.preferences.brix ? this.$roundNumber((((182.4601 * wineFermentation.fsg -775.6821) * wineFermentation.fsg +1262.7794) * wineFermentation.fsg -669.5622), 1) : wineFermentation.fsg;
      this.setFSG = true;
    },
    async saveFSG() {
      if (!this.$refs.fsg.validate())
        return;
      const fsg = this.preferences.brix ? this.$roundNumber((this.fsg / (258.6-((this.fsg / 258.2)*227.1))) + 1, 3) : this.fsg;
      const results = await this.$apiCall(`mutation ProductionWineFermenting($id: ID!, $fsg:Float!) {
                                              wineFermentationSetFSG(id:$id, fsg:$fsg) {
                                                fsg,alc
                                              }
                                            }`,
                                            {id:this.wineFermentation.id,fsg});
      if (!results.error) {
        this.wineFermentation.fsg = results.data.wineFermentationSetFSG.fsg;
        this.wineFermentation.alc = results.data.wineFermentationSetFSG.alc;
        this.setFSG = false;
      }
    },

    async printBatch() {
      const lines = [];
      let n = this.selected.length;
      for (const wineFermentation of this.selected) {
        lines.push(... await this.print(wineFermentation.id, null, false));
        if (--n)
          lines.push(`<div class="page-break"/>`);
      }
      this.printHtml('Wine fermentation', lines.join(''));
    }
  },

  i18n: {
    messages: {
      en: {
        title: 'Wine fermenting',
        header: {
          date: 'DATE',
          produces: 'PRODUCED',
          comments: 'COMMENTS',
          duration: 'DURATION',
          lot: 'LOT',
          fsg: 'FSG',
          osg: 'OSG',
          alc: 'ALC',
          ph: 'PH',
          litres: 'LITRES',
          value: 'VALUE'
        }
      },
      fr: {
        title: 'Fermentation du vin',
        header: {
          date: 'DATE',
          produces: 'PRODUIT',
          comments: 'COMMENTAIRES',
          duration: 'DURÉE',
          lot: 'PARCELLE',
          fsg: 'GSF',
          osg: 'GSO',
          alc: 'ANS',
          ph: 'PH',
          litres: 'LITRES',
          value: 'VALEUR'
        }
      }
    }
  }
}
</script>